<template>
  <div>
    <v-card class="card-curvey d-flex align-center" :color="$vuetify.theme.secondary" elevation="0" dark>
        <img src="../../../../assets/img/messaging.png"   alt="">
      <div>
        <h1>{{ common.numberWithCommas(remaining) }} Remaining</h1>
        <p class="mb-0">Of {{common.numberWithCommas(total)}} Total Package</p>
      </div>
    </v-card>
    <v-card class="card-curvey d-flex align-center" :color="$vuetify.theme.warning" elevation="0" dark>
      <img src="../../../../assets/img/campagin.png"   alt="">
      <div>
        <h1>{{
          overallData.campaignPackage.total_campaigns ?
           common.numberWithCommas(overallData.campaignPackage.total_campaigns)
           : 0
          }} Campaigns</h1>
        <p class="mb-0">{{overallData.campaignPackage.sent_campaigns_count}} Sent</p>
      </div>
    </v-card>
    <v-card class="card-curvey d-flex align-center" :color="$vuetify.theme.third" elevation="0" dark>
      <img src="../../../../assets/img/message-campagins.png"   alt="">
      <div>
        <h1>{{
          $_.sumBy(overallData.accumulatedMsgsStatus, s => s.count)
         }} Messages</h1>
        <p class="mb-0">Sent To Users</p>
      </div>
    </v-card>
  </div>
</template>

<script>
  import common from "../../../../utils/analytics/common";
  export default {
    name: "campaignsNumbers",
    props: {
      overallData: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
    data () {
      return {
        common,
        result: null
      }
    },
    mounted() {
      this.getConsumptionData()
    },
    computed: {
      consumed() {
        return this.result && this.result.length && this.result[0]['Packages.sessionConsumed'] ? this.result[0]['Packages.sessionConsumed'] :0
      },
      total() {
        return this.result && this.result.length && this.result[0]['Packages.sessionsTotal'] ? this.result[0]['Packages.sessionsTotal'] :0
      },
      remaining() {
        return this.total - this.consumed
      },
    },
    methods: {
      getConsumptionData() {
      const query = {
      "dimensions": [
        "Packages.sessionConsumed",
        "Packages.sessionsTotal"
      ],
      "timeDimensions": [],
      "order": {
        "Packages.sessionTotal": "asc"
      },
      "filters": [
        {
          "member": "Packages.type",
          "operator": "equals",
          "values": [
            "outbound"
          ]
        },
        {
          "member": "Accounts.accountKey",
          "operator": "equals",
          "values": [
            this.$store.state.settings.settings.licence_id
          ]
        }
      ]
    }
    // this.$store.state.settings.settings.licence_id
      this.$http_cube({
        url: 'cubejs-api/v1/load',
        method: 'get',
        params: {
            query
          }
      }).then(res => {
          this.result = res.data.data
        })
    }
    }
  }
</script>

<style scoped>
img {
  width:45px;
  max-width: 45px;
  margin-right: 30px;
}
  @media (max-width: 1627px) {
    h1 {
      font-size: 22px;
    }
  }
@media (max-width: 1440px) {
  h1 {
    font-size: 18px;
  }
}
  .card-curvey {
    border: 2px solid white !important;
  }
</style>
